module.exports = __webpack_public_path__ + "../resources/img/mon_graph_img4.2623d8bb.png";